import classNames from 'classnames'
import { Link } from 'gatsby';
import React from 'react'

const HelpLink = (injectedStyle = '') => ({ children }) => (
  <Link to="/help" className={classNames(injectedStyle)}>{children}</Link>
)

export default HelpLink
